/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerDeviceCarrierUpdateDto } from '../models/EntityModelResponseContainerDeviceCarrierUpdateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramSimSlotControllerService {
    /**
     * @returns EntityModelResponseContainerDeviceCarrierUpdateDto OK
     * @throws ApiError
     */
    public static list({
        deviceId,
    }: {
        deviceId: number,
    }): CancelablePromise<EntityModelResponseContainerDeviceCarrierUpdateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/sim-slots/{deviceId}',
            path: {
                'deviceId': deviceId,
            },
        });
    }
}
